import { Dispatch, SetStateAction, createContext } from "react";
import { Donor } from "../../models";

export interface IDonorsContext {
    donor: Donor | undefined;
    setDonor: Dispatch<SetStateAction<Donor | undefined>>;
    isFetchingDonor: boolean;
    setIsFetchingDonor: Dispatch<SetStateAction<boolean>>;
    isSavingDonor: boolean;
    setIsSavingDonor: Dispatch<SetStateAction<boolean>>;
    isLocked: boolean;
    lockedByName: string;
    unlockDonor: (donorId: number | string) => Promise<void>;
    isSerologiesLocked: boolean;
    flag: (isFlagged: boolean, flagNote: string) => Promise<Donor | undefined>;
    isLockedByMe: boolean;
    isDedSigned: boolean;
    disabled: boolean;
}

const defaultValue: IDonorsContext = {
    donor: undefined,
    setDonor: () => {},
    isFetchingDonor: false,
    setIsFetchingDonor: () => {},
    isSavingDonor: false,
    setIsSavingDonor: () => {},
    isLocked: false,
    lockedByName: "",
    unlockDonor: async () => {},
    isSerologiesLocked: false,
    flag: async () => undefined,
    isLockedByMe: false,
    isDedSigned: false,
    disabled: false,
};

export const DonorsContext = createContext<IDonorsContext>(defaultValue);
DonorsContext.displayName = "Donors";
